import { useMfaServiceMfaLockoutsList } from '@organization/api/queries'
import { MFALockout } from '@organization/api/requests'
import { TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import { LockoutsFilters, LockoutsHeader, LockoutsTable } from '../components'

export const LockoutsPage = () => {
  const { t } = useTranslation()

  const { params, updateQuery } = useQueryUpdate()

  const { triggerSort, getSortedTableColumns } = useSorting<MFALockout>()

  const { data, isLoading } = useMfaServiceMfaLockoutsList(params)

  return (
    <>
      <TitleSection
        title={t('menu.lockouts_users')}
        count={data?.count}
        isLoading={isLoading}
      >
        <LockoutsHeader />
      </TitleSection>

      <Flex vertical gap={16}>
        <LockoutsFilters />

        <LockoutsTable
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page: number, pageSize: number) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
